module.exports = __webpack_public_path__ + "img/dey.21034e47.png";